import { render, staticRenderFns } from "./GoogleSignUpButton.vue?vue&type=template&id=3c90b0c6&scoped=true&"
import script from "./GoogleSignUpButton.vue?vue&type=script&lang=js&"
export * from "./GoogleSignUpButton.vue?vue&type=script&lang=js&"
import style0 from "./GoogleSignUpButton.vue?vue&type=style&index=0&id=3c90b0c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c90b0c6",
  null
  
)

export default component.exports